import React, { useEffect, useState } from 'react'
import MySpiner from '../../../../UI/spiner/MySpiner'
import MySelect from '../../../../UI/form/MySelect'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { getSupplierTypesAPI } from '../../../../../api/supply/supplierAPI'

const SupplierTypeSelect = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [types, setTypes] = useState([])

	const [loading, setLoading] = useState(false)

	useEffect(() => {
		getTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getTypes = () => {
		setLoading(true)
		getSupplierTypesAPI().then(data => {
			setTypes(data)
			setLoading(false)
		}).catch(e => {
			// setError(responseError(e))
			setLoading(false)
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
	<>
		{
			loading ?
				<MySpiner />
			:
				<MySelect
					value={value ? value : ''}
					label="Тип"
					labelId="select__supplierType-label"
					id='select__supplierType'
					onChange = {e => {
						setValueForm(e)
						setValue(e)
						// setEvent({...event, categoryId: e})
					}}
					nameField='Тип'
					// sx={{width: '200px'}}
					options={
						types && types.length > 0 ? 
							types.map(type => {
								return {id: type.id, name: type.name}
							})
						: []	
					}
					// options={[]}
				/>
		}
	</>
  )
}

export default SupplierTypeSelect